import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService, ModalSize } from '@cv-invision/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NexsysMonitorService } from '../../../service/nexsys-monitor.service';
import { ORIGIN, URLS } from '../../model/nexsys-monitor.constant';
import { RetryNexsysEventComponent } from '../retry-nexsys-event/retry-nexsys-event.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { GlobalConfigurationEnumsState } from '../../../state/global-configuration-enums.state';

@Component({
	selector: 'cv-invision-custom-action-grid-cell',
	templateUrl: './custom-action-grid-cell.component.html',
	styleUrls: ['./custom-action-grid-cell.component.scss']
})
export class CustomActionRetryCellComponent implements ICellRendererAngularComp, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	public cellValue: any;
	isNexsys: boolean;
	canRetry: boolean;
	origin: string;
	retryActions = {};
	retryAction = null;

	/**
	 * @deprecated
	 */
	canNotRetry: boolean;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private store: Store,
		private modalService: ModalService,
		private nexsysMonitorService: NexsysMonitorService,
		private router: Router
	) {}

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
		this.retryActions = this.store.selectSnapshot(GlobalConfigurationEnumsState.getRetryActions);

		const url = this.router.url;
		Object.keys(URLS).forEach(urlKey => {
			if (url.includes(URLS[urlKey])) {
				const key = Object.keys(ORIGIN).find(originKey => {
					const pattern = /[^a-zA-Z0-9]/gm;
					const cleanUrlKey = urlKey.toLowerCase().replace(pattern, '');
					const cleanOriginKey = (ORIGIN[originKey as keyof typeof ORIGIN] || '')
						.toLowerCase()
						.replace(pattern, '');

					return cleanOriginKey === cleanUrlKey;
				});

				if (key) {
					this.origin = ORIGIN[key];
					this.canRetry = true;
					if (this.cellValue.action.includes('CALLBACK_')) {
						this.canRetry = false;
						this.canNotRetry = true;
					}

					switch(ORIGIN[key]) {
						case ORIGIN.Xpanse:
						case ORIGIN.LandGorilla:
							this.canRetry = true;
							this.canNotRetry = false;
							break;

						case ORIGIN.OrderExternal:
							this.canRetry = true;
							this.canNotRetry = false;
							if (!this.cellValue.action.includes('CALLBACK_')) {
								this.canRetry = false;
								this.canNotRetry = true;
							}
							break;
					}
				}
			}
		});

		if (Object.keys(this.retryActions).length ) {
			this.canRetry = false;
			if (this.cellValue.action in this.retryActions) {
				this.retryAction = this.retryActions[this.cellValue.action];
				this.canRetry = this.retryAction.canRetry;
			}
		}
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}

	/**
	 * retry call
	 */
	onRetryCall(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RetryNexsysEventComponent,
				data: {
					...this.cellValue,
					source: this.origin,
					retryAction: this.retryAction
				},
				modalConfiguration: {
					title: `${this.origin} Retry Event`,
					modalSize: ModalSize.LG
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.nexsysMonitorService.reloadList({ reload: true });
				} else {
					// it failed :(
				}
			});
	}

	/**
	 * On component destroy
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
